/**
 * api 都集中在这里
 * */
import {
  sendDelete,
  sendGet,
  sendGetErr,
  // sendGetMes,
  sendPost,
  sendPostErr,
  sendPut
  // sendPutErr
} from "@/utils/base";
// 反馈专用 无cookie --------------------
import axios from "axios";
// 创建axios实例常量配置
const axiosCreate = {
  timeout: 30000,
  withCredentials: false,
  validateStatus: function(status: number) {
    return status < 400;
  }
};
const noCookieHttp = axios.create(axiosCreate);
// --------------------

// const prefix =
// "http://api.admin.zhiyinlou.com/server/index.php?g=Web&c=Mock&o=simple&projectID=119&uri=";
const prefix = process.env.VUE_APP_API_URL;
const feedPreFix = process.env.VUE_APP_FEED_URL;
// 登陆者~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 退出
// yach 部门id 换 dd 部门id
export const exchangeDepId = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/yach/depts`, params);

//成员列表
export const getUsersList = (params: Object) =>
  sendGet(`${prefix}/permission/users`, params);
// 删除用户
export const delUser = (workcode: string) =>
  sendDelete(`${prefix}/permission/user/${workcode}`);
// 部门
export const getDpTree = (params: Object = {}) =>
  sendGet(`${prefix}/admin/first-level-departments`, params);
// 用户相关配置
export const getUserConf = () => sendGet(`${prefix}/permission/config`);
// 用户信息
export const getUserInfo = (workcode: string) =>
  sendGet(`${prefix}/permission/user/${workcode}`);
// 用户基本信息,模糊搜索
export const searchUserBasicInfo = (params: Object) =>
  sendPost(`${prefix}/permission/search-employee`, params);
// 添加用户
export const addUser = (params: Object) =>
  sendPost(`${prefix}/permission/user`, params);
// 修改用户信息
export const modifyUserInfo = (workcode: string, params: Object) =>
  sendPut(`${prefix}/permission/user/${workcode}`, params);
// 用户禁用
export const toggleUserAvaliablity = (workcode: string, params: Object) =>
  sendPost(`${prefix}/permission/user/${workcode}/disable`, params);
// -----------  pc okr --------------//

// 获取用户职级信息
export const getLevel = () => sendGet(`${prefix}/api/level`);

// 获取okr获取模板
export const getTemplates = () => sendGet(`${prefix}/api/templates`);

// 获取评论接口
export const getCommentList = (id: string, params: Object) =>
  sendGet(`${prefix}/api/o/${id}/comments`, params);

// 添加评论接口
export const subComment = (oid: string, params: Object) =>
  sendPost(`${prefix}/api/o/${oid}/comments`, params);

// 删除评论接口
export const delComment = (oid: string, cid: string, params: Object) =>
  sendDelete(`${prefix}/api/o/${oid}/comments/${cid}`, params);

// 新建okr  (已废弃 2018 10.9)
// export const postOkr = (params: Object) =>
//   sendPostErr(`${prefix}/api/okr`, params);

// 新建okr  v2
export const postOkr = (params: Object) =>
  sendPostErr(`${prefix}/api/v2/okr`, params);

// 编辑okr  v2
export const putOkr = (params: Object) =>
  sendPostErr(`${prefix}/api/v2/okr`, params);

// 获取 编辑页面 的okr 详情
export const getV2OkrEdit = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/v2/okr/edit/${id}`, params);

// 新建草稿
// export const postOkrDraft = (params: Object) =>
//   sendPostErr(`${prefix}/api/okr/draft`, params);

// 用户搜索
export const getUser = (params: Object) =>
  sendGet(`${prefix}/api/user/search`, params);

// 获取object列表接口
export const getObjectList = (id: string, params: Object) =>
  sendGet(`${prefix}/api/okr/${id}/os`, params);

// 获取object详情
export const getObjectDetail = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/o/${id}`, params);

// 获取点赞列表
export const getLikeList = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/o/${id}/likes`, params);

// 获取点赞、取消
export const pointeLike = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/o/${id}/likes`, params);

// 我的okr （废弃）
// export const getMyOkr = (params: Object) =>
//   sendGet(`${prefix}/api/okr`, params);

// 我的okr
export const getMyOkr = (params: Object) =>
  sendGet(`${prefix}/api/v2/okr`, params);

// // okr列表 / 集团okr / 搜索okr
// export const getOkrHome = (params: Object) =>
//   sendPost(`${prefix}/api/home`, params);

// okr列表 / 集团okr / 搜索okr
export const getOkrHome = (params: Object) =>
  sendGet(`${prefix}/api/v2/home`, params);

// 读取 okr
export const getOkrRead = (id: number | string) =>
  sendPostErr(`${prefix}/api/okr/${id}/visitors`, {});

// 删除 okr （2018.10.9 废弃）
// export const deleteMyOkr = (id: [string, number], params: Object) =>
//   sendDelete(`${prefix}/api/okr/${id}`, params);

// 删除 okr
export const deleteMyOkr = (id: [string, number], params: Object) =>
  sendDelete(`${prefix}/api/v2/okr/${id}`, params);

// 获取 okr详情
export const getOkrInfo = (id: [string, number], params: Object) =>
  sendGetErr(`${prefix}/api/okr/${id}`, params);

// 获取 okr详情
export const getTreeList = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/okr/${id}`, params);
// 搜索用户OKR
export const getUserOkr = (workcode: [string, number], params: Object) =>
  sendGet(`${prefix}/api/user/${workcode}/okr`, params);

// OKR信息接口，编辑页
export const getEditOkr = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/okr/${id}/show`, params);

// **  我的关注 */
//关系树/api/o/{id}/tree
export const getOkrTree = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/o/${id}/tree`, params);

//关系树/api/o/{id}/tree
export const getOkrAligns = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/o/${id}/kr_down_aligns`, params);
// 关注用户的okr列表
// export const getMyFollowers = (params: Object) =>
//   sendGet(`${prefix}/api/my/followers`, params);
// 关注用户的okr列表 V2
export const getMyFollowers = (params: Object, id: string | number = "all") =>
  sendGet(`${prefix}/api/v2/follwer/okrs/${id}`, params);

// 关注用户的 user 列表 V2
export const getUserFollowers = (params: Object = {}) =>
  sendGet(`${prefix}/api/v2/user/followers`, params);

// OKR 编辑功能 OKR更新接口(2018.10.10 已废弃，修改为 与 新建okr 相同)
// export const putOkr = (id: [string, number], params: Object) =>
//   sendPutErr(`${prefix}/api/okr/${id}`, params);

// 关注操作
export const markMethod = (
  type: string,
  id: [string, number],
  params: Object
) => sendPost(`${prefix}/api/${type}/${id}/followers`, params);

// 收藏操作
export const collectMethod = (
  type: string,
  id: [string, number],
  params: Object
) => sendPost(`${prefix}/api/${type}/${id}/favorites`, params);

// OKR关注/取消关注
// export const postOkrFollowers = (id: [string, number], params: Object) =>
//   sendPost(`${prefix}/api/okr/${id}/followers`, params);

// OKR关注/取消关注 V2
export const postOkrFollowers = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/v2/user/${id}/followers`, params);

// O 关注/取消关注
export const postOFollowers = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/o/${id}/followers`, params);

// **  我的收藏 */

export const getMyFavorites = (params: Object) =>
  sendGet(`${prefix}/api/my/favorites`, params);

// OKR关注/取消收藏
export const postOkrFavorites = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/okr/${id}/favorites`, params);
// O 关注/取消收藏
export const postOFavorites = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/o/${id}/favorites`, params);

/***   全局搜索 */
export const postSearch = (params: Object) =>
  sendPostErr(`${prefix}/api/search`, params);

/***   用户 搜索 */
export const postSearchUser = (params: Object) =>
  sendPost(`${prefix}/api/search/users`, params);

/***   o 搜索 */
export const postSearchOkr = (params: Object) =>
  sendPost(`${prefix}/api/search/okrs`, params);

/*** 浏览量 */
export const pageViewVal = (id: [string, number], params: Object) =>
  sendPost(`${prefix}/api/okr/${id}/visitors`, params);
/*** 反馈收集 */
export const feedback = (params: Object) => {
  return noCookieHttp.post(`${feedPreFix}/feedback/oapi/v1/issue`, params);
  // return sendPost(`${feedPreFix}/feedback/oapi/v1/issue`, params);
};

/*** 推荐对标人 */
export const getRecommend = (params: Object) =>
  sendGet(`${prefix}/api/v2/recommend/upalign/users`, params);

/*** 导入上一篇 */
export const importLastokr = (params: Object) =>
  sendGet(`${prefix}/api/v2/okr/import`, params);

// 我@TA
export const meAt = (params: Object) =>
  sendGet(`${prefix}/api/v2/okrat/him`, params);

// TA@我
export const atMe = (params: Object) =>
  sendGet(`${prefix}/api/v2/okrat/me`, params);

// 有无任务未完成
export const task = (params: Object) =>
  sendGet(`${prefix}/api/v2/okrat/status`, params);

//-----------------上下平级、我的对标-------------------------

//获取模版list
export const getLevelTemplates = (params: Object) =>
  sendGet(`${prefix}/api/template/list`, params);

//我的上级和平级
export const getOkrTopLevl = (params: Object) =>
  sendGet(`${prefix}/api/v2/super_equal_user/okrs`, params);

//我的下级列表
export const getOkrSubLevl = (params: Object) =>
  sendGet(`${prefix}/api/v2/sub_user/okrs`, params);

// 未写OKR下级
export const noWriteSubordinates = (params: Object) =>
  sendGet(`${prefix}/api/v2/sub_user/notice`, params);

//我的对标
export const getOkrMarKMe = (params: Object) =>
  sendGet(`${prefix}/api/v2/align`, params);

// 待对标列表
export const getStayOnList = (id: [string, number], params: Object) =>
  sendGet(`${prefix}/api/v2/okrat/template/me?template_id=${id}`, params);
// 首次/非首次进入创建okr
export const isFirstEnterCreateOkr = (item: [string, number], params: Object) =>
  sendGet(`${prefix}/api/v2/okr/first/visit?item=${item}`, params);
